import { ActiveExperimentGetter } from 'frontend/types';
import { ExperimentLike } from 'frontend/experiments/types';

/**
 * Gets the active treatment for the experiment passed in using the experimentGetter.
 * Note you don't need to provide Type to use this helper function. It will be inferred from the
 * generic type of ExperimentLike<Type>.
 *
 * @param activeExperimentGetter - An ActiveExperimentGetter instance. Usually pulled from vuex
 *   ...mapGetters('globals', ['privacyProperties', 'getActiveTreatment']),
 * @param experiment: The experiment object. Needs to conform to the `ExperimentLike<Type>`
 *   interface
 *
 * @example
 * // for an example on how to initialize myAwesomeExperiment see the ExperimentLike<Type>
 * //  definition
 * getActiveTreatment(activeExperimentGetter, myAwesomeExperiment)
 *
 */
export function getActiveTreatment<Type extends string>(
  activeExperimentGetter: ActiveExperimentGetter,
  experiment: ExperimentLike<Type>,
): Type {
  return activeExperimentGetter(experiment.name) as Type;
}
